import React from 'react';
import { Layout } from 'antd';
import CommonHeader from "../components/commonHeader";
import { Outlet } from "react-router-dom";
import styles from './main.module.css';

const { Content, Footer } = Layout;

const MainLayout = () => {
    return (
        <Layout className={styles.container}>
            <CommonHeader />
            <Content className={styles.content}>
                <Outlet />
            </Content>
            <Footer className={styles.footer}>
                <p>&copy; 2026 西安誉致智能科技有限公司</p>
                <p>
                    <a
                        href="https://beian.miit.gov.cn"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                    >
                        陕ICP备2026002960号-5
                    </a>
                </p>
            </Footer>
        </Layout>
    );
}

export default MainLayout;